import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';

import { MeasureTableModel } from '../shared/model/measure-table.model';
import { MeasureTableService } from '../shared/service/measure-table.service';
import { MessageComponent } from '../shared/component/message/message.component';

@Component({
    selector: 'app-measure-table',
    templateUrl: './measure-table.component.html',
    styleUrls: ['./measure-table.component.css']
})
export class MeasureTableComponent implements OnInit {

    @ViewChild(MessageComponent) message: MessageComponent;

    lastEvent: any;
    totalRecords: number;
    searchQuery: string = '';

    measureTables: MeasureTableModel[] = [];

    // ── Aplicar em mais produtos ─────────────────────────────────────────
    showApplyDialog: boolean = false;
    applyLoading: boolean = false;
    sourceTable: any = null;
    applyTargets: Array<{ model_code: string; product_description: string }> = [];

    constructor(
        private measureTableService: MeasureTableService,
        private router: Router
    ) { }

    ngOnInit() { }

    lazy(e) {
        this.lastEvent = e;
        this.measureTableService.getPaginated(e.first, e.rows, this.searchQuery).subscribe(
            (result) => {
                this.measureTables = result['rows'] as MeasureTableModel[];
                this.totalRecords = result['count'];
            },
            () => this.message.error()
        );
    }

    search() {
        if (this.lastEvent) {
            this.lastEvent.first = 0;
            this.lazy(this.lastEvent);
        }
    }

    private resolveId(table: any): number {
        return table.id || table.measure_table_id;
    }

    onNew() {
        this.router.navigate(['/measure-table', 'new']);
    }

    onEdit(table: any) {
        const id = this.resolveId(table);
        if (!id) { this.message.error(); return; }
        this.router.navigate(['/measure-table', id]);
    }

    onDuplicate(table: any) {
        const id = this.resolveId(table);
        if (!id) { this.message.error(); return; }
        this.measureTableService.duplicate(id).subscribe(
            () => {
                this.message.success('success_save_message');
                this.lazy(this.lastEvent);
            },
            () => this.message.error()
        );
    }

    onDelete(table: any) {
        const id = this.resolveId(table);
        if (!id) { this.message.error(); return; }
        this.measureTableService.delete(id).subscribe(
            () => {
                this.message.success('success_save_message');
                this.lazy(this.lastEvent);
            },
            () => this.message.error()
        );
    }

    // ── Aplicar em mais produtos ─────────────────────────────────────────

    openApplyDialog(table: any) {
        this.sourceTable = table;
        this.applyTargets = [{ model_code: '', product_description: '' }];
        this.showApplyDialog = true;
    }

    addApplyTarget() {
        this.applyTargets.push({ model_code: '', product_description: '' });
    }

    removeApplyTarget(index: number) {
        if (this.applyTargets.length > 1) {
            this.applyTargets.splice(index, 1);
        }
    }

    canApply(): boolean {
        return this.applyTargets.length > 0 &&
            this.applyTargets.every(t => !!(t.model_code && t.model_code.trim()) &&
                                         !!(t.product_description && t.product_description.trim()));
    }

    applyToProducts() {
        if (!this.canApply()) return;
        this.applyLoading = true;

        const id = this.resolveId(this.sourceTable);

        this.measureTableService.getById(id).subscribe(
            (sourceData: any) => {
                const requests = this.applyTargets.map(target => {
                    const payload: any = {
                        origin: sourceData.origin || 'manual',
                        name: sourceData.name,
                        model_code: target.model_code.trim(),
                        product_description: target.product_description.trim(),
                        grid_labels: sourceData.grid_labels,
                        measures: sourceData.measures
                    };
                    return this.measureTableService.post(payload);
                });

                Observable.forkJoin(requests).subscribe(
                    () => {
                        this.applyLoading = false;
                        this.showApplyDialog = false;
                        this.message.success('success_save_message');
                        this.lazy(this.lastEvent);
                    },
                    () => {
                        this.applyLoading = false;
                        this.message.error();
                    }
                );
            },
            () => {
                this.applyLoading = false;
                this.message.error();
            }
        );
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/measure-table/measure-table.component.ts